<mat-toolbar color="primary" class="toolbar">
	@if (isMobile()) {
		<div class="toolbar-row">
			@if (loggedIn()) {
				<button matMiniFab (click)="menuClick.emit()">
					<mat-icon>menu</mat-icon>
				</button>
			}
			<span class="title">Ratio Connect</span>
			@if (loggedIn()) {
				<button matMiniFab [matMenuTriggerFor]="userMenu">
					<mat-icon>account_circle</mat-icon>
				</button>
			}
		</div>
	} 
	@else {
		<img class="logo" src="/assets/logo-white.svg" alt="Ratio Connect" />

		<span class="title desktop-title"><h1>Ratio Connect</h1></span>
		<span class="spacer"></span>

		@if (loggedIn()) {
			<span class="user-info">{{ displayName() }}</span>
			<button matMiniFab [matMenuTriggerFor]="userMenu">
				<mat-icon>account_circle</mat-icon>
			</button>
		}
	}

	<mat-menu #userMenu="matMenu">
		@if (isMobile()) {
			<div class="menu-header">
				<div class="menu-name">{{ displayName() }}</div>
			</div>
		}
		<button mat-menu-item (click)="signOut()" i18n="@@Logout">Logout</button>
	</mat-menu>

</mat-toolbar>
